<div class="modal-header">
  <h5 class="modal-title">{{ 'Clone Favourites and Tasks' | messageTranslate:{equipment:selectedEquipment.name} }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<form (ngSubmit)="onSubmit()">
  <div class="modal-body">

    <div class="py-3">
      <h6 >{{ 'Clone Favourites and Tasks Help' | messageTranslate:{equipment:selectedEquipment.name} }}</h6>
    </div>

    <app-equipment-select
      name="chosenEquipment"
      [(ngModel)]="chosenEquipment"
      [options]="equipment"
      [multiSelect]="true"
      [placeholder]="'Equipment' | messageTranslate"
      [hideSelected]="false"
      (ngModelChange)="onChange()"
      [maxSelectedLabels]="null"/>

    @if (equipment?.length <= MAX_EQUIPMENT_FOR_SELECT_ALL) {
      <button class="btn btn-link p-0" type="button" (click)="selectAll($event)">{{'Select All' | messageTranslate}}</button>
    }

    <div class="mt-3">
      @for (alert of alerts; track $index) {
        <p>
          <ngb-alert [type]="alert.type" [dismissible]="false">{{alert.message.messageKey | messageTranslate:alert.message.parameters}}</ngb-alert>
        </p>
      }
    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="!atLeastOneValidEquipment || checking">
      <fa-icon [appShowFaSpinner]="checking" icon="clone" class="ms-2"/>
      {{ 'Copy' | messageTranslate }}
    </button>
    <button type="button" ngbAutofocus class="ms-2 btn btn-secondary" (click)="activeModal.dismiss('Close')">{{ 'Close' | messageTranslate }}</button>
  </div>
</form>
